import Styles from './Styles';

export default Styles.HeaderInfoGroup;
